import React from 'react';
import { observer } from 'mobx-react';

import UpsertModal from './components/upsert-modal';

import AdminTableLayout from 'components/admin-table-layout';
import Title from 'components/admin-table-layout/components/title';
import TableHeader from 'components/admin-table-layout/components/table-header';
import EntriesCount from 'components/admin-table-layout/components/table-header/components/entries-count';
import Paginator from 'components/paginator';
import NewEntryButton from 'components/admin-table-layout/components/table-header/components/new-entry-button';
import ListSearch from 'components/drill-down-layout/components/list/components/list-header/components/list-search';
import TableContent from 'components/admin-table-layout/components/table-content';
import SmartTable from 'components/smart-table';

import {
  MAX_TABLE_ENTRIES_PER_PAGE,
  TECHNICIAN_MANIPULATION_OPTIONS,
} from './constants';

import './smart-table-work-places-styles.scss';

const AdminTechniciansView = ({
  type,
  store,
  routeStore,
  upsertModalRouteStore,
  smartTableColumns,
  sortTechnicians,
  changePaginationPage,
  onTechniciansSearch,
  showUpsertModal,
  closeUpsertModal,
  addWorkPlaceLocally,
  removeWorkPlaceLocally,
  onWorkPlacesSearch,
  createTechnician,
  updateTechnician,
  deleteTechnician,
  showDeleteConfirmationModal
}) => (
  <React.Fragment>
    <UpsertModal
      technicianType={type}
      upsertModalRouteStore={upsertModalRouteStore}
      routeStore={routeStore}
      addWorkPlaceLocally={addWorkPlaceLocally}
      removeWorkPlaceLocally={removeWorkPlaceLocally}
      onWorkPlacesSearch={onWorkPlacesSearch}
      createTechnician={createTechnician}
      updateTechnician={updateTechnician}
      deleteTechnician={deleteTechnician}
      closeUpsertModal={closeUpsertModal}
      showDeleteConfirmationModal={showDeleteConfirmationModal}
    />
    <AdminTableLayout>
      <Title
        text={`${type} Technicians`}
      />
      <TableHeader>
        <div className='left-area'>
          <EntriesCount
            count={store.entriesCount}
            caption={`${type} Technicians`}
          />
          <Paginator
            currentPage={routeStore.currentPage}
            entriesCount={store.entriesCount}
            entriesPerPage={MAX_TABLE_ENTRIES_PER_PAGE}
            changePage={changePaginationPage}
          />
        </div>
        <div className='right-area'>
          <NewEntryButton
            caption={`New ${type} Technician`}
            onClick={e => showUpsertModal(e, TECHNICIAN_MANIPULATION_OPTIONS.CREATE)}
          />
          <ListSearch
            searchValue={routeStore.filterValue}
            onSearch={onTechniciansSearch}
          />
        </div>
      </TableHeader>
      <TableContent>
        <SmartTable
          sortingFieldName={routeStore.sortingColumn.fieldName}
          sortingOrder={routeStore.sortingColumn.sortingOrder}
          onSortIconClick={sortTechnicians}
          rows={routeStore.forTable}
          onRowClick={(e) => showUpsertModal(e, TECHNICIAN_MANIPULATION_OPTIONS.UPDATE)}
          columns={smartTableColumns}
          loading={routeStore.loading}
        />
      </TableContent>
    </AdminTableLayout>
  </React.Fragment>
);

export default observer(AdminTechniciansView);
